export default __webpack_public_path__ + "assets/close-component.90b058cd.svg";